import { createContext } from 'react'

export interface IntlContextInterface {
  messages: i18n.TranslationMap
}

export const IntlContext = createContext<IntlContextInterface>({ messages: {} })
